// Cargo visibility (taxgw-8lvi): the ONE client-side policy for "is this mirror entity an embarked ground unit?".
// The synced TransportPassenger state is the only source (PassengerState.embarked). Queued and needsTransport units are
// ashore and remain ordinary actors: they keep their health bar, lock line and position lookups. The sim's matching
// rule is participatesIndependently (sim/src/world/participation.ts), which every authoritative boundary reads.

import type { Entity } from '@esengine/ecs-framework'
import { PassengerState, TransportPassenger } from '@taxwar/net'

/** Whether a mirror entity is an embarked ground unit (cargo) right now: hidden from the war as an independent actor. */
export function isEmbarkedCargo(entity: Entity): boolean {
  const passenger = entity.getComponent(TransportPassenger)
  return passenger !== null && passenger.state === PassengerState.embarked
}
